"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = NotFoundPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var dotlottie_react_1 = require("@lottiefiles/dotlottie-react");
var _404_blue_lottie_1 = __importDefault(require("../assets/lotties/404-blue.lottie"));
// When downloading Lotties, be sure to download the "dotLottie" format! (.lottie extension)
function NotFoundPage() {
    return ((0, jsx_runtime_1.jsx)("div", { className: "p-4 flex justify-center items-center h-full", children: (0, jsx_runtime_1.jsx)("div", { className: "w-96 h-96", children: (0, jsx_runtime_1.jsx)(dotlottie_react_1.DotLottieReact, { src: _404_blue_lottie_1.default, loop: true, autoplay: true }) }) }));
}
